import React from 'react';
export function Divider() {
  return <div className="w-full flex justify-center py-12" data-id="element-237">
      <div className="flex items-center gap-4 opacity-40" data-id="element-238">
        <div className="h-px w-16 bg-terracotta" data-id="element-239"></div>
        <div className="w-2 h-2 rounded-full bg-gold" data-id="element-240"></div>
        <div className="h-px w-16 bg-terracotta" data-id="element-241"></div>
      </div>
    </div>;
}